<div class="modal-header">
  <h4 class="modal-title pull-left">
    {{ title }}
  </h4>
  <button type="button" class="close pull-right" aria-label="Close modal" (click)="close(false)">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body" [innerHTML]="text"></div>
<div class="modal-footer">
  <button nkButton [color]="secondaryBtnColor" [ghost]="true" (click)="close(false)">
    {{ 'common.cancel' | translate }}
  </button>
  <button nkButton [color]="mainBtnColor" (click)="close(true)">
    @if (mainBtnLabel) {
      {{ mainBtnLabel }}
    } @else {
      {{ 'common.ok' | translate }}
    }
  </button>
</div>
